<div
  class="noprint bg-blue-400 text-white p-4"
  layout-padding
  md-scroll-shrink
  md-shrink-speed-factor="0.5"
>
  <div class="max-w-7xl mx-auto py-6 px-4 sm:py-12 sm:px-6 lg:px-8">
    <div class="flex flex-col lg:flex-row gap-8">
      <div>
        <h2 class="text-xl lg:text-2xl mb-2">Maritime Fotos</h2>
        <p>
          Seit 2008 finden Sie auf maritime-photographie jeden Tag ein neues
          Schlaglicht aus dem weiten Feld der Schifffahrt.
        </p>
        <p>
          Durchsuchen Sie das Archiv, welches knapp 8000 Fotos umfasst, nach
          Elbfotos, Bildern aus dem norddeutschen Raum, von Schiffen und
          Containerriesen.
        </p>
      </div>
      <div class="flex flex-col md:flex-row gap-8">
        <div class="flex flex-col">
          <h2 class="text-xl lg:text-2xl mb-2">Kontakt</h2>

          <div class="flex space-x-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            Wolfgang K. Reich
          </div>
          <div class="flex space-x-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
              />
            </svg>
            Königsbergstr. 153 | 22880 Wedel
          </div>
          <div class="flex space-x-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              />
            </svg>
            +49 4103 6674
          </div>
          <div class="flex space-x-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            reich[at]maritime-photographie[dot]de
          </div>
          <br />
        </div>
        <div>
          <h2 class="text-xl lg:text-2xl mb-2">Infos</h2>
          <button
            class="
              inline-flex
              items-center
              my-2
              px-4
              py-2
              border border-gray-300
              shadow-sm
              text-base
              font-medium
              rounded-md
              text-white
              hover:bg-blue-800
              focus:outline-none
              focus:ring-2
              focus:ring-offset-2
              focus:ring-blue-400
            "
            [routerLink]="['/datenschutz']"
          >
            Datenschutz
          </button>
          <br />
          <button
            class="
              inline-flex
              items-center
              my-2
              px-4
              py-2
              border border-gray-300
              shadow-sm
              text-base
              font-medium
              rounded-md
              text-white
              hover:bg-blue-800
              focus:outline-none
              focus:ring-2
              focus:ring-offset-2
              focus:ring-blue-400
            "
            [routerLink]="['/impressum']"
          >
            Impressum
          </button>
          <br />
          <button
            class="
              inline-flex
              items-center
              my-2
              px-4
              py-2
              border border-gray-300
              shadow-sm
              text-base
              font-medium
              rounded-md
              text-white
              hover:bg-blue-800
              focus:outline-none
              focus:ring-2
              focus:ring-offset-2
              focus:ring-blue-400
            "
            [routerLink]="['/links']"
          >
            Links
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
